import { useEffect } from "react";
import { useMeetingStore } from "../../store/meeting.store";
import { PublicViewer } from "../Icons";
import { socket } from "../mediasoup/socket";

const ViewerButton = () => {
  const viewerShow = useMeetingStore((s) => s.viewerShow);
  const setViewerShow = useMeetingStore((s) => s.setViewerShow);
  const viewers = useMeetingStore((s) => s.viewers);
  const setViewers = useMeetingStore((s) => s.setViewers);
  useEffect(() => {
    if (!socket) return;

    const onAdd = (data: any) => {
      const exists = viewers.some((v: any) => v.userId === data.userId);

      if (!exists) {
        setViewers([...viewers, data]);
      }
    };

    const onRemove = (data: any) => {
      const updatedViewers = viewers.filter(
        (v: any) => v.userId !== data.userId,
      );

      setViewers(updatedViewers);
    };
    const onStreamStoped = ({ sessionId }: any) => {
      const updatedViewers = viewers.filter((v: any) => v.cnr === sessionId);

      setViewers(updatedViewers);
    };

    socket.on("viewer_added", onAdd);
    socket.on("viewer_removed", onRemove);
    socket.on("stream_stop", onStreamStoped);

    return () => {
      socket.off("viewer_added", onAdd);
      socket.off("viewer_removed", onRemove);
      socket.off("stream_stop", onStreamStoped);
    };
  }, [socket, setViewers, viewers]);
  return (
    <button
      onClick={() => setViewerShow(!viewerShow)}
      className="shadow-lg p-3 bg-white w-40 items-center flex justify-center cursor-pointer relative"
    >
      <span className="font-semibold absolute top-1 right-1 text-white bg-blue-900 rounded-full px-2 flex items-center justify-center ">
        {viewers?.length || 0}
      </span>
      <PublicViewer className="" />
    </button>
  );
};

export default ViewerButton;
